const findInFileChildren = (file, action) => {
  action(file);

  if (file.children) {
    for (const child of file.children) {
      findInFileChildren(child, action);
    }
  }
};

export default findInFileChildren;



// WEBPACK FOOTER //
// ./src/utility/findInFileChildren.js